import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchCheckoutSummary = createAsyncThunk(
  'checkout/fetchSummary',
  async (lang, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userTools"));
      // //console.log(token?.token);

      const response = await axios.post(
        `${BASE_URL}/order-summary`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token?.token}`,
            "Accept-Language": lang || "en",
          },
        }
      );

      return response.data.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch order summary";
      return rejectWithValue({ message });
    }
  }
);
